require('./mountain-route-images.html');
require('./mountain-route-images.controller');
